/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
export const MESSAGES = {
  CUSTOMER_NAME_TEXT:
    "Company name, such as Panasonic Corporation, used for display purposes.",
  JPOWER_ID_TEXT: "Identifier for the customer account located in Salesforce.",
};

export const TITLE = {
  SAVE: "Save",
  CANCEL: "Cancel",
  JPOWER_ID: "JPower ID",
  ADD_CUSTOMER: "Add Customer",
  EDIT_CUSTOMER: "Edit Customer",
  CUSTOMER_NAME: "Customer Name",
};
